import { Action } from '@ngrx/store';
import { CardRefresh } from '../../model/ngrx/card-refresh.model';
import * as CardRefreshActions from './../actions/card-refresh.actions';

export type Actions = CardRefreshActions.Actions;

const initialState: CardRefresh = {
    setCardRefresh: true
   
};

export function cardRefreshReducer(state: CardRefresh[] = [initialState], action: CardRefreshActions.Actions) {
    switch (action.type) {
        case CardRefreshActions.ADD_CARD_REFRESH:
            return [...state, action.payload];
        case CardRefreshActions.REMOVE_CARD_REFRESH:
            state = [];
            return state;

        default:
            return state;
    }
}